import { render, staticRenderFns } from "./DialogAddWeb.vue?vue&type=template&id=19f740f8&scoped=true"
import script from "./DialogAddWeb.vue?vue&type=script&lang=js"
export * from "./DialogAddWeb.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19f740f8",
  null
  
)

export default component.exports